import { SimpleErrorLayout } from 'components/Layout/SimpleErrorLayout';
import { Webline } from 'components/Layout/Webline/Webline';
import {
    ErrorPageButtonLinkStyled,
    ErrorPageStyled,
    ErrorPageTextHeadingStyled,
    ErrorPageTextMainStyled,
    ErrorPageTextStyled,
} from 'components/Pages/ErrorPage/ErrorPage.style';
import { isWithToastAndConsoleErrorDebugging } from 'helpers/errors/isWithErrorDebugging';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { FallbackProps } from 'react-error-boundary';

export const Error500WithBoundary: FC<FallbackProps> = ({ resetErrorBoundary }) => {
    const router = useRouter();

    useEffect(() => {
        router.events.on('routeChangeComplete', resetErrorBoundary);

        return () => {
            router.events.off('routeChangeComplete', resetErrorBoundary);
        };
    }, [resetErrorBoundary, router.events]);

    return <Error500 />;
};

type Error500Props = {
    err?: string;
};

export const Error500: FC<Error500Props> = ({ err }) => {
    const { t } = useTranslation();

    return (
        <SimpleErrorLayout>
            <Webline>
                <ErrorPageStyled>
                    <ErrorPageTextStyled>
                        <ErrorPageTextHeadingStyled>{t('Something went wrong.')}</ErrorPageTextHeadingStyled>
                        <ErrorPageTextMainStyled>{t('Please try again later or contact us.')}</ErrorPageTextMainStyled>
                        <ErrorPageButtonLinkStyled isButton href="/">
                            {t('Back to shop')}
                        </ErrorPageButtonLinkStyled>
                    </ErrorPageTextStyled>
                    {isWithToastAndConsoleErrorDebugging && err && (
                        <div className="my-3 flex justify-center">
                            <div className="rounded bg-greyLighter">
                                <div className="p-3">
                                    <p>{err}</p>
                                </div>
                            </div>
                        </div>
                    )}
                </ErrorPageStyled>
            </Webline>
        </SimpleErrorLayout>
    );
};
